import isEqual from 'lodash/isEqual'
import { useEffect } from 'react'
import { usePrevious } from 'react-use'

type UseHasChangedProps<T> = {
  // Set to false to let a change pass without writing it to the form. The previous value is
  // still tracked, so the skipped change won't be written on a later render either.
  enabled?: boolean
  fieldKey: string
  currentValue: T | undefined | null
  setValue: (name: string, value: unknown) => void
  valueToSet: unknown
}

export function useResetFormFieldOnChange<T>({
  enabled = true,
  fieldKey,
  currentValue,
  setValue,
  valueToSet,
}: UseHasChangedProps<T>) {
  const previousData = usePrevious(currentValue)
  const hasChanged = !isEqual(previousData, currentValue)

  useEffect(() => {
    if (enabled && hasChanged) {
      setValue(fieldKey, valueToSet)
    }
  }, [enabled, hasChanged, valueToSet, fieldKey, setValue])
}
